import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as mui from '@material-ui/core'

export default function PostalCodeInput (props) {
  const { labelText, inputProps } = props
  const [value, setValue] = useState(inputProps.value ?? '')

  useEffect(() => {
  }, [])

  function formatPostalCode (input) {
    // 郵便番号をxxx-xxxxの形に変換する
    let value = input
      .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
      .replace(/[^0-9]/g, '')
    if (value.length > 7) {
      value = value.slice(0, 7)
    }
    if (value.length > 3) {
      value = value.slice(0, 3) + '-' + value.slice(3)
    }
    setValue(value)
  }

  return (
    <>
      <mui.TextField
        variant="standard"
        id={inputProps.id}
        name=""
        type='text'
        required={inputProps.required}
        value={value}
        label={labelText}
        placeholder=""
        error={inputProps.error}
        helperText={inputProps.helperText}
        className='w-100'
        InputProps={{
          className: inputProps.class,
          disabled: inputProps.readonly
        }}
        onChange={(e) => {
          setValue(e.target.value)
        }}
        onBlur={(e) => {
          formatPostalCode(value)
        }}
      />
      <input type="text" name={inputProps.name} className="d-none" value={value} readOnly />
    </>
  )
}

PostalCodeInput.propTypes = {
  labelText: PropTypes.string,
  inputProps: PropTypes.object
}

const elem = $('.postal-code-input')
elem.each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  const elLabel = qel.find('label')
  props.labelText = elLabel.length > 0 ? elLabel[0].innerText : ''
  const elInput = qel.find('input')
  if (elInput.length) {
    const qInput = $(elInput[0])
    props.inputProps = {}
    'id,name,value,required,readonly,class'.split(',').forEach((name) => {
      if (qInput.prop(name)) {
        props.inputProps[name] = qInput.prop(name)
      }
    })
    if (qInput.hasClass('is-invalid')) {
      props.inputProps.error = true
    }

    const elInvalidFeedback = qel.find('.invalid-feedback')
    props.inputProps.helperText = elInvalidFeedback.length > 0 ? elInvalidFeedback[0].innerText : ''
  } else {
    console.error('postal-code-inputクラスの子要素には必ずinput要素を配置してください。')
    return
  }
  ReactDOM.render(<PostalCodeInput {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
